import {
    EMPLOYEES_SEND_NOTIFICATION_CLEAR,
    GET_USERS_ACTION_REQUEST,
    GET_USERS_ACTION_SUCCESS,
    GET_USERS_ACTION_FAILURE,
    GET_USERS_ACTION,
    ADD_ROLE_ACTION_REQUEST,
    ADD_ROLE_ACTION_SUCCESS,
    ADD_ROLE_ACTION_FAILURE,
    ADD_ROLE_ACTION,
    DELETE_ROLE_ACTION_REQUEST,
    DELETE_ROLE_ACTION_SUCCESS,
    DELETE_ROLE_ACTION_FAILURE,
    DELETE_ROLE_ACTION
} from './constants';
import {Data, User, Action} from '../types';

export const clearNotification = (): Action => ({
    type: EMPLOYEES_SEND_NOTIFICATION_CLEAR
});

export const fetchUsersRequest = (): Action => ({
    type: GET_USERS_ACTION_REQUEST
});

export const fetchUsersSuccess = (users: Data[]): Action => ({
    type: GET_USERS_ACTION_SUCCESS,
    users
});

export const fetchUsersError = (message: string): Action => ({
    type: GET_USERS_ACTION_FAILURE,
    message
});

export const fetchUsers = () => ({
    type: GET_USERS_ACTION
});

export const addRoleRequest = (): Action => ({
    type: ADD_ROLE_ACTION_REQUEST
});

export const addRoleSuccess = (): Action => ({
    type: ADD_ROLE_ACTION_SUCCESS,
    success: 'success'
});

export const addRoleError = (error: string): Action => ({
    type: ADD_ROLE_ACTION_FAILURE,
    error
});

export const addRole = (user: User) => ({
    type: ADD_ROLE_ACTION,
    user
});

export const deleteRoleRequest = (): Action => ({
    type: DELETE_ROLE_ACTION_REQUEST
});

export const deleteRoleSuccess = (): Action => ({
    type: DELETE_ROLE_ACTION_SUCCESS,
    success: 'success'
});

export const deleteRoleError = (error: string): Action => ({
    type: DELETE_ROLE_ACTION_FAILURE,
    error
});

export const deleteRole = (user: User) => ({
    type: DELETE_ROLE_ACTION,
    user
});
